var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationTpopam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.4062H20.3125V20.3125H18.75V16.4062ZM15.625 12.5H17.1875V20.3125H15.625V12.5ZM8.59375 20.3125C7.55813 20.3113 6.56528 19.8993 5.83298 19.167C5.10069 18.4347 4.68874 17.4419 4.6875 16.4062H6.25C6.25 16.8698 6.38746 17.3229 6.64499 17.7084C6.90253 18.0938 7.26857 18.3942 7.69684 18.5716C8.1251 18.749 8.59635 18.7954 9.05099 18.705C9.50564 18.6145 9.92325 18.3913 10.251 18.0635C10.5788 17.7358 10.802 17.3181 10.8925 16.8635C10.9829 16.4089 10.9365 15.9376 10.7591 15.5093C10.5817 15.0811 10.2813 14.715 9.89587 14.4575C9.51044 14.2 9.0573 14.0625 8.59375 14.0625V12.5C9.62975 12.5 10.6233 12.9116 11.3559 13.6441C12.0884 14.3767 12.5 15.3702 12.5 16.4062C12.5 17.4423 12.0884 18.4358 11.3559 19.1684C10.6233 19.9009 9.62975 20.3125 8.59375 20.3125Z",
    fill: "#176318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 1.5625H3.125C2.7106 1.5625 2.31317 1.72712 2.02015 2.02015C1.72712 2.31317 1.5625 2.7106 1.5625 3.125V21.875C1.5625 22.2894 1.72712 22.6868 2.02015 22.9799C2.31317 23.2729 2.7106 23.4375 3.125 23.4375H21.875C22.2892 23.4369 22.6863 23.2721 22.9792 22.9792C23.2721 22.6863 23.4369 22.2892 23.4375 21.875V3.125C23.4375 2.7106 23.2729 2.31317 22.9799 2.02015C22.6868 1.72712 22.2894 1.5625 21.875 1.5625ZM21.875 8.59375H10.9375V3.125H21.875V8.59375ZM9.375 3.125V8.59375H3.125V3.125H9.375ZM3.125 21.875V10.1562H21.875L21.8766 21.875H3.125Z",
    fill: "#176318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationTpopam);
export default __webpack_public_path__ + "static/media/OperationTPOPAM.339b7d5e85d752e75efaef31667149c0.svg";
export { ForwardRef as ReactComponent };